var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.chartData && _vm.chartData.series)?_c('ApexChart',{attrs:{"element":"PortFuelCharacteristics","chartOption":_vm.chartData,"series":_vm.chartData.series}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }